import { Popup } from './Popup.js';
// CLASS PopupRemoveCard:
export class PopupWithConfirmation extends Popup {
  constructor({ popupSelector, defaultText }) {
    super(popupSelector);
    this._popupForm = this._popup.querySelector('.popup__form');
    this._defaultText = defaultText;
    this._buttonSubmit = this._popup.querySelector('.popup__button');
  }

  isDeletingText(isDeleting) {
    if(isDeleting === true) {
      this._buttonSubmit.textContent = 'Удаляю...';
      this._buttonSubmit.disabled = true;

    } else {
      this._buttonSubmit.textContent = this._defaultText;
      this._buttonSubmit.disabled = false;

    }
  }

  setEventListeners() {
    super.setEventListeners();
    this._popupForm.addEventListener('submit', (event) => {
      event.preventDefault();
      this._handleSubmit()
      // this.close()
    });
  }
  setSubmitAction(submitAction) {
    this._handleSubmit = submitAction;
  }
}